import PropTypes from 'prop-types';

const Leave = ({ color }) => (
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5768 8.97376C15.753 7.42735 15.4436 5.86445 14.6917 4.50172C13.9398 3.139 12.7826 2.04394 11.3804 1.36837C9.97831 0.692802 8.40072 0.47018 6.86639 0.731368C5.33206 0.992556 3.91699 1.72462 2.81735 2.82606C1.71771 3.92751 0.987979 5.34378 0.729311 6.87854C0.470643 8.4133 0.695856 9.99051 1.37373 11.3915C2.0516 12.7926 3.14855 13.948 4.51251 14.6977C5.87648 15.4473 7.43988 15.7541 8.98599 15.5754M8.1252 3.95874V8.12541L9.79187 9.79207M12.2919 12.2921V16.4587M15.6252 12.2921V16.4587"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Leave.propTypes = {
  color: PropTypes.string,
};

Leave.defaultProps = {
  color: '#696F7C',
};

export default Leave;
